// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__13LdH","amount":"Amount_amount__1jzJ4","tip":"Amount_tip__3wZV6","tipHeader":"Amount_tipHeader__LRgR5","tipsWrap":"Amount_tipsWrap__2awJG"};